module.exports = __webpack_public_path__ + "img/Icon-11.ac5e21b9.png";